import { createContext, useContext, useState } from "react";

interface Context {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

const VerListagemContext = createContext<Context>({
  isOpen: false,
  setIsOpen: () => null
});

const Provider: React.FC = ({ children }) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <VerListagemContext.Provider
      value={{
        isOpen,
        setIsOpen
      }}
    >
      {children}
    </VerListagemContext.Provider>
  );
};

export const useVerListagem = (): Context => useContext(VerListagemContext);

export default Provider;
